/* src/app/shared/controls/side-panel/side-panel.component.scss */
.sidepanel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(100% - 95px);
  background: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(1.5px);
  backdrop-filter: blur(1.5px);
  z-index: 99;
}
.sidebar {
  width: fit-content;
  min-width: 400px;
  position: fixed;
  top: 135px;
  right: 0;
  height: calc(100% - 200px);
  padding: 0 20px;
  background-color: #fff;
  color: #1d1d1d;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 100;
  transform: translateX(100%);
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebar.visible {
  display: flex;
  animation: sidepanel-slide-in 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(0);
}
.sidebar .header-container {
  display: flex;
  z-index: 2;
  top: 0;
  position: sticky;
  background: #fff;
  border-bottom: 1px solid #d3d3d3;
}
.sidebar .content-container {
  display: flex;
  flex: 1 1 auto;
  overflow-y: auto;
  margin-bottom: 30px;
}
.sidebar .button-container {
  display: flex;
  z-index: 2;
  position: relative;
  bottom: 30px;
  padding: 15px;
  gap: 10px;
  background: #fff;
  border-top: 1px solid #d3d3d3;
}
.sidebar h2 {
  padding: 0 5px;
  border-radius: 5px;
  font-size: xx-large;
  color: #006f8a;
}
@keyframes sidepanel-slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}
/*# sourceMappingURL=side-panel.component-N57G4RYG.css.map */
